import { Deserializable } from '../protocols/deserializable';
import { CreditCardStatusEnum } from '../enum/shared/credit-card-status-enum';

export class MemberCreditCard implements Deserializable {
  public id!: number;
  public cardType!: string;
  public last4Digits!: string;
  public expiryMonth!: string;
  public expiryYear!: string;
  public statusId!: CreditCardStatusEnum;
  public createdDate!: string;
  public inUse!: boolean;

  onDeserialize(): void {}
}
